import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { rxResource } from "@angular/core/rxjs-interop";
import { catchError, map, of } from "rxjs";
import { ApiService } from "../core/api.service";
import { Settings } from "../core/models";

@Component({
  selector: "app-business-settings-page",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, RouterModule],
  templateUrl: "./business-settings-page.component.html",
  styleUrls: ["./settings-form-page.component.scss"],
})
export class BusinessSettingsPageComponent {
  private readonly api = inject(ApiService);

  form: Settings = {
    companyName: "Do Your Shades",
    contactEmail: "",
    contactPhone: "",
    address: "",
    timezone: "America/Chicago",
    defaultRate: 250,
    defaultDiscount: 0,
    measurementUnit: "in",
    warrantyMonths: 6,
    autoCloneModel: true,
    warnMeasurementVariance: true,
    includeInstallation: true,
    includeSolarPanels: true,
    depositPercent: 50,
    remotePerRoom: 1,
    remoteControls: 6,
    terms: [],
    salesHours: "Mon - Fri 8am to 11pm ET, Sat - Sun 8am to 9pm ET",
    serviceHours: "Mon - Fri 8am to 11pm ET, Sat - Sun 8am to 9pm ET",
    commercialHours: "Mon - Fri 8am to 6pm ET",
    commercialContact: "Contact Commercial Sales",
    constructionBannerEnabled: true,
    constructionBannerText:
      "This page is still under construction — please do not place orders yet. The website is not fully functional.",
  };

  readonly saving = signal(false);
  readonly message = signal("");

  private readonly settingsResource = rxResource({
    stream: () =>
      this.api.getSettings().pipe(
        map((settings) => {
          this.form = { ...this.form, ...settings };
          return settings;
        }),
        catchError(() => {
          this.message.set("Failed to load settings.");
          return of(null);
        }),
      ),
  });

  save() {
    this.saving.set(true);
    this.api.updateSettings(this.form).subscribe({
      next: (settings) => {
        this.form = { ...this.form, ...settings };
        this.message.set("Settings saved.");
        this.saving.set(false);
      },
      error: () => {
        this.message.set("Failed to save settings.");
        this.saving.set(false);
      },
    });
  }
}
